<template>
  <div class="containar">
    <div class="clock-contents-block">
      <div>
        <div id="clock" class="content-cl" v-bind:class="fontStyle" v-bind:style="{color: colors.hex}">
          <span class="date" v-bind:class="dateOn">{{ date }}</span>
          <span class="time">{{ time }}</span>
        </div>
      </div>
    <div class="set">
      <h3>日付の有無</h3>
      <div class="radio-main">
        <label><input type="radio" value="on" v-model="hide" />日付あり</label>
        <label><input type="radio" value="off" v-model="hide" />日付なし</label>
      </div>
      <h3>カラー選択</h3>
      <div class="radio-main">
        <chrome-picker :value="colors" v-model="colors"></chrome-picker>
      </div>
      <h3>フォント選択</h3>
      <div class="radio-main">
        <label><input type="radio" value="font1" v-model="fontsytle" /><div class="font1 select-font">09:54</div></label>
        <label><input type="radio" value="font2" v-model="fontsytle" /><div class="font2 select-font">09:54</div></label>
        <label><input type="radio" value="font3" v-model="fontsytle" /><div class="font3 select-font">09:54</div></label>
        <label><input type="radio" value="font4" v-model="fontsytle" /><div class="font4 select-font">09:54</div></label>
      </div>
      <h3>配信ソフト用URL</h3>
      <p>各項目を選択するとURLが自動的に生成されます。</p>
      <p>OBSならば、ソースの「ブラウザ」を追加→下記URLを入力すると表示できます。</p>
      <div class="radio-main">
        <input :value="urlInput + '?txcolor=' + this.colorsCng + '&font=' + fontsytle + '&hide=' + hide" id="target" type="text" readonly class=" m-form-text" />
        <button @click="copy" class="copy-btn">コピー</button>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
import {Chrome} from 'vue-color'
export default {
  name: "app",
  components: {
    'chrome-picker': Chrome,
   },
  data() {
    return {
      date: "",
      time: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
      hide: "on",
      fontsytle:'font1',
      urlInput:'https://ruri.info/tool/clockdesign',
      colors: {
        hex: '#194d33',
        hsl: { h: 150, s: 0.5, l: 0.2, a: 1 },
        hsv: { h: 150, s: 0.66, v: 0.30, a: 1 },
        rgba: { r: 25, g: 77, b: 51, a: 1 },
        a: 1
        },
    };
  },
  mounted: function () {
    setInterval(this.updateTime, 1000);
  },
  methods: {
    updateTime: function () {
      //現在の日付・時刻を取得
      let currentdate = new Date();

      // 現在の時刻
      this.time =
        this.zeroPadding(currentdate.getHours(), 2) +
        ":" +
        this.zeroPadding(currentdate.getMinutes(), 2);
      // this.zeroPadding(currentdate.getSeconds(), 2);

      // 現在の年月日
      this.date =
        this.zeroPadding(currentdate.getFullYear(), 4) +
        "-" +
        this.zeroPadding(currentdate.getMonth() + 1, 2) +
        "-" +
        this.zeroPadding(currentdate.getDate(), 2) +
        " " +
        this.week[currentdate.getDay()];
    },
    zeroPadding: function (num, len) {
      let zero = "";

      // 0の文字列を作成
      for (var i = 0; i < len; i++) {
        zero += "0";
      }

      // zeroの文字列と、数字を結合し、後ろ２文字を返す
      return (zero + num).slice(-len);
    },
    copy () {
      if(navigator.clipboard){
        navigator.clipboard.writeText(this.urlInput + '?font=' + this.fontsytle + '&hide=' + this.hide + '&txcolor=' + this.colorsCng)
        console.log('コピー完了')
        return true
      } else {
        return false
      }
    },
  },
  computed: {
    colorsCng: function(){
        return this.colors.hex.split('#').join('')
    },
    dateOn: function() {
      if (this.hide === 'off') {
        return 'date-off';
      }
      else {
        return '';
      }
    },
    fontStyle: function() {
      if (this.fontsytle === 'font1') {
        return 'font1';
      }
      else if (this.fontsytle === 'font2') {
        return 'font2';
      }
      else if (this.fontsytle === 'font3') {
        return 'font3';
      }
      else if (this.fontsytle === 'font4') {
        return 'font4';
      }
      else {
        return '';
      }
    },
  },
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Iceland&family=Open+Sans:wght@500&family=Shadows+Into+Light&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Yuji+Mai&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Klee+One:wght@600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Single+Day&display=swap');

p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}
.containar{
  margin: 0 auto;
  max-width: 767px;
}


h3{
  font-size: 14px;
  margin-top: 24px;
}


.clock-contents-block{
  text-align: left;
  display: -webkit-flex;
	display: flex;
	-webkit-flex-wrap: nowrap;
	flex-wrap: nowrap;
	justify-content: center;
	align-items: center;
  margin: 24px auto;
  min-width: 0;
  height: 100%;
}

@media screen and (max-width: 630px) {
  .clock-contents-block{
    display: block;
    margin: 0 auto;
  }

  .set{
    margin-top:24px;
    margin-left: 0px!important;
  }
}

#clock {
  text-align: center;
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 auto;
  padding: 12px 24px 12px 24px;
  line-height: 1;
  border-radius: 10px;
  color: #fff;
  -webkit-align-self: flex-start;
	align-self: flex-start;
  white-space: nowrap;
}

.time {
  letter-spacing: 0.05em;
  font-size: 80px;
  line-height: 0.9em;
}

.date {
  padding-top: 12px;
  letter-spacing: 0.1em;
  font-size: 24px;
  display: block;
}

.set{
  padding: 8px 12px 24px 12px;
  background-color: #FFFEF9;
  border-radius: 10px;
  -webkit-align-self: flex-start;
	align-self: flex-start;
  margin-left:24px
}
.select-gradation{
  text-align: center;
  background-color: aliceblue;
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 auto;
  padding: 24px 24px 12px 24px;
  line-height: 1;
  border-radius: 10px;
  margin-right: 12px;
}

.select-font{
  text-align: center;
  background-color: aliceblue;
  width: -moz-fit-content;
  width: fit-content;
  width: 48px;
  padding: 12px 18px 12px 18px;
  line-height: 1;
  border-radius: 10px;
  margin-right: 12px;
}

.date-off{
  display:none;
}

.font1{
  font-family: "Open Sans", sans-serif;
}
.font2{
  font-family: 'Iceland', cursive;
}
.font3{
  font-family: 'Single Day', cursive;
}
.font4{
  font-family: 'Klee One', cursive;
}
.radio-main{
  display: -webkit-flex;
  display: flex;
  flex-wrap: wrap;
  margin-top:12px;
  box-sizing: border-box;
}
.m-form-text{
  height: 2.4em;
  padding: 0 16px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.copy-btn{
  background-color: #fff;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
}

.copy-btn:active{
  -webkit-transform: translateY(4px);
  transform: translateY(4px);
  border-bottom: none;
}
</style>